import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

export const translateList = (keys: string[]) => {
  return keys.map(key => translateWithI18Next(key)).join(' ');
};
